import { disconnect } from 'common/sockets/afterSalesProjects';

export default () => disconnect();
